<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    @import ./hero
    @import ./video
    @import ./engagements
    @import ./keys
    @import ./actus

</style>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import $ from 'jquery'
    import { union, each } from 'lodash/core'
    // import Isotope from 'isotope-layout'

    export default {
        components: {
            swiper,
            swiperSlide
        },
        mounted () {
            this.initArticlesTags();

            setTimeout(() => {
                window.AOS.init({disable: 'mobile', offset: 30})
            }, 1000);

        },
        data () {
            return {
                keySwiperOption: {
                    nextButton: '.node-homepage-corporate__keys__right .arrow--right',
                    prevButton: '.node-homepage-corporate__keys__right .arrow--left',
                    loop: false
                },
                publicationsSwiperOption: {
                    nextButton: '.node-homepage-corporate__keys__left .arrow--right',
                    prevButton: '.node-homepage-corporate__keys__left .arrow--left',
                    loop: false,
                    onSlideChangeStart: (swiper) => {
                        $(swiper.slides[swiper.activeIndex]).addClass("leave");
                    },
                    onSlideChangeEnd: (swiper) => {
                        $(swiper.slides[swiper.activeIndex]).removeClass("leave");
                    },
                    effect: 'fade',
                    fade: {
                        crossFade: false
                    }
                },
                articlesTagsOptions: [],
                articlesTag: "all"
            }
        },
        watch: {
            articlesTag: function() {
                this.showArticles();
            },

        },
        methods: {

            initArticlesTags: function() {
                let articles = $('.node-homepage-corporate__actus__item');

                articles.each((index, obj) => {
                    let $obj = $(obj);
                    let classes = _($obj.attr('class').split(' '))
                        .filter( item => item.indexOf('tag-') > -1 )
                        .map ( item => item.replace('tag-', ''))
                        .value();
                    this.articlesTagsOptions = union(this.articlesTagsOptions, classes);
                })

                this.showArticles();
            },

            showArticles() {
                let $articles = $('.node-homepage-corporate__actus__item');
                $articles.hide().removeClass('first');

                let nb = 0;

                each($articles, (article) => {
                    let $article = $(article);

                    if ( nb < 3 ) {
                        if ( this._showArticle($article) )
                            nb++;
                    }

                });

                $articles.filter(':visible').eq(0).addClass('first');

                let _foo = () => {
                    if ( $articles.filter(':visible').length > 3 && $articles.filter(':visible').length % 3 !== 0) {
                        let articles = $articles.filter(':visible');
                        $(articles[articles.length - 1]).hide();
                        setTimeout(_foo, 10);
                    }
                };
                _foo();


            },

            _showArticle($article) {
                let flag = false;

                if ( this.articlesTag && this.articlesTag !== "all" ) {
                    if ( $article.hasClass('tag-' + this.articlesTag) ) {
                        $article.show();
                        flag = true;
                    }
                } else {
                    $article.show();
                    flag = true;
                }

                return flag;
            },

            scroll() {
                $('html, body').animate({
                    scrollTop: $(".node-homepage-corporate__video").offset().top
                });
            },

            scrollToArticles() {
                $('html, body').animate({
                    scrollTop: $(".node-homepage-corporate__actus").offset().top - 50
                });
            }

        }
    }

</script>
